import React from 'react';
import { string, array, bool, number } from 'prop-types';

import { Carousel } from '@snapask/common-components';

import MediaCard from './components/MediaCard';
import NextArrow from './components/Arrows/NextArrow';
import PrevArrow from './components/Arrows/PrevArrow';

import styles from './ChannelBar.scss';
import { Link } from 'react-router-dom';

function ChannelBar({ name, posts, nameHref, needCarousel, hintText, id }) {
  const config = {
    slidesToShow: 4,
    slidesToScroll: 4,
    draggable: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          arrows: false,
          // it workaround for center mode without left padding
          centerPadding: '50px 0 0',
        },
      },
    ],
  };

  const nameNode = !!nameHref ? (
    <Link className={styles.link} to={nameHref}>
      {name}
    </Link>
  ) : (
    name
  );

  return (
    <section className={styles.root}>
      <h1 className={styles.title}>
        <a href={`/channel/${id}`} className={styles.link}>
          <span className={styles.text}> {nameNode} </span>
          {!!hintText && (
            <span className={styles.hoverWrapper}>
              <span className={styles.hintText}>{hintText}</span>
            </span>
          )}
        </a>
      </h1>

      {needCarousel ? (
        <Carousel settings={config}>
          {posts.map(post => (
            <MediaCard
              {...post}
              key={post.id}
              className={styles.carouselItem}
            />
          ))}
        </Carousel>
      ) : (
        <ul className={styles.postList}>
          {posts.map((post, index) => (
            <li className={styles.listItem} key={index}>
              <MediaCard {...post} smallMedia={index !== 0} key={post.id} />
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

ChannelBar.propTypes = {
  id: number.isRequired,
  name: string.isRequired,
  posts: array.isRequired,
  hintText: string,
  nameHref: string,
  needCarousel: bool,
};

ChannelBar.defaultProps = {
  nameHref: '',
  needCarousel: false,
};

export default ChannelBar;



// WEBPACK FOOTER //
// ./app/components/ChannelBar/ChannelBar.jsx